const { default: favorites } = require("@/store/modules/landing/favorites");

module.exports = {
  landing: {
    popularCourses: "Популярные курсы",
    allCourses: "Все курсы",
    tutoring: "Репетиторство и частные уроки",
    vacancies: "Вакансии",
    allCoursesForMobile: "Курсы",
    popularCoursesForMobile: "Популярные",
    tutoringForMobile: "Репетитор",
    vacanciesForMobile: "Вакансия",
    main: "Главная",
    favorites: "Избранное",
    support: "Тех. поддержка",
    forCenters: "Для центров",
    loginBtn: "Вход",
    profileBtn: "Профиль",
    exitBtn: "Выйти",
    zerekTitlePart1: "Дополнительное",
    zerekTitlePart2: "образование",
    mainSlideTitle:
      "Обеспечьте вашему ребенку дополнительное образование уже сегодня!",
    mainSlideDescription:
      "Отправьте заявку прямо сейчас, чтобы записать вашего ребенка на курсы и секции — бесплатно или на платной основе!",
    mainSlideBtnText: "Отправить заявку",
    zerekInfoTitle: "Zerek EDUS",
    zerekInfoText1:"Добро пожаловать на Zerek EDUS — вашу идеальную платформу для поиска кружков и секций для детей! На платформе вы найдете широкий выбор спортивных, творческих и научных секций, которые подойдут детям любого возраста и интересов.",
    zerekInfoText2: "центры",
    zerekInfoText3: "курсы",
    zerekInfoText4: "на рынке",
    zerekInfoTitle4: "2023 г.",
    year: "лет",
    zerekInfoText5:
      "На платформе вы найдете широкий выбор спортивных, творческих и научных секций, которые подойдут детям любого возраста и интересов. Образовательные центры, преподователи и тренеры с лучшими программами, направленные на развитие навыков и интересов вашего ребенка. Zerek EDUS: Откройте мир увлечений для вашего ребенка!",
    coursesTitle: "Курсы",
    videoBlockTitle: "Хотите узнать больше о платформе?",
    videoBlockDescription:
      "Нажмите на кнопку ниже и посмотрите видеоинструкцию!",
    videoBlockBtn: "Посмотреть видеоролик",
    closeVideoModal: "Закрыть",
    topOrganizationsTitle: "Топ-организации",
    topTeachersTitle: "Более 100+ опытных преподавателей ",
    reviewsTitle: "Отзывы родителей",
    shown: "",
    from: "",
    seeAll: "Посмотреть все",
    stars: "звезда",
    questionsTitle: "Часто задаваемые",
    questionsTitleStyled: "вопросы",
    questionTitle1: "Почему мой ребенок не отображается в личном кабинете?",
    questionDescription1:
      "Чтобы добавить ребенка в систему, в своем личном кабинете откройте раздел «Дети» и нажмите кнопку «Добавить ребенка». После нажатия на кнопку на ваш номер телефона, зарегистрированный в Базе мобильных граждан (БМГ), придет SMS-сообщение. В ответ на это сообщение отправьте код-цифру, соответствующую слову «Да», указанному в SMS. После отправки кода нажмите кнопку «Обновить» в открывшемся меню. Если ребенок так и не появился, обратитесь в службу технической поддержки.",
    questionTitle2:
      "Как зарегистрироваться в системе? Почему не могу войти в личный кабинет?",
    questionDescription2:
      "На нашей платформе регистрация в системе осуществляется с помощью ключа ЭЦП (электронно-цифровой подписи) пользователя. Поэтому для входа в систему используйте ноутбук или персональный компьютер с установленной программой NCALayer. Скачать программу NCALayer можно на официальном сайте Национального удостоверяющего центра РК.",
    questionTitle3: "Почему при регистрации запрашиваются мои личные данные?",
    questionDescription3:
      "На платформе личные данные пользователей запрашиваются для правильного внесения данных о ваших детях, подтверждения подлинности личности, обеспечения прозрачности в системе, а также для корректного оформления документов при приеме в организации дополнительного образования в соответствии с приказом Министра образования и науки Республики Казахстан от 22 мая 2020 года №219. Эти меры необходимы для предотвращения подачи ложных или недобросовестных заявок, а также для точного внесения информации о лице. Все личные данные пользователей в нашей системе хранятся и защищаются в соответствии с Законом Республики Казахстан от 21 мая 2013 года № 94-V «О персональных данных и их защите».",
    questionTitle4:
      "Для чего отправляется СМС-сообщение? На какие данные я даю согласие?",
    questionDescription4:
      "На платформе Zerek EDUS информация о ребенке берется из системы ГБД ФЛ (Государственная база данных «Физические лица»). Получение данных о ребенке из этой системы возможно только с разрешения его родителей, поэтому вам отправляется SMS-протокол для получения согласия.",
    questionTitle5: "Почему СМС-сообщение не приходит на мой номер телефона?",
    questionDescription5:
      "SMS-протокол для получения разрешения отправляется только на номер, зарегистрированный в Базе мобильных граждан (БМГ). Если SMS-протокол не приходит на ваш номер, войдите в личный кабинет на портале eGov и проверьте, правильно ли указан номер телефона.\n" +
      "Если контактный номер указан неверно или не был введён, воспользуйтесь инструкцией по обновлению номера по следующей ссылке: https://egov.kz/cms/kk/articles/mobilecitizen. Если номер зарегистрирован верно, но SMS-протокол всё равно не приходит, обратитесь в службу технической поддержки нашей платформы.",
    footerTitle: "Всегда на связи!",
    edusSystems: "EDUS System © 2025",
    rights: "Все права защищены",
    footerAboutCompany: "О компании",
    footerConsultationTitle: "Хотите получить консультацию?",
    footerSendBtn: "Отправить",
    footerFormLabel: "Почта",
    useConditions: "Условия использования",
    privacyPolicy: "Политика конфиденциальности",
    zerekTitle: "Дополнительное образование",
    students: "студентов учится",
    "noTopOrganizations": "Пока нет топ-организаций",
    "beTheFirst": "Станьте первым!",
  },

  allCourses: {
    circlesTab: "Образовательные курсы",
    sportcoursesTab: "Спортивные курсы",
    culturecoursesTab: "Творческие курсы",
    centersTab: "Учебные центры",
    favoritesTab: "Избранные",
    searchLabel: "Поиск курсов",
    backBtn: "Назад",
    teacher: "Преподаватель",
    price: "Цена",
    month: "месяц",
    shareCourse: "Поделиться курсом",
    numberOfGrades: "оценок",
    applyForCourse: "Подать заявку на курс",
    requirements: "Требования",
    whyPeople: "Почему люди выбирают",
    choose: "?",
    studyTime: "Время учебы",
    availableSeats: "Кол-во свободных мест",
    hour_week: "час/неделя",
    backButton: "Назад",
    numberOfCourses: "Кол-во курсов",
    numberOfContingents: "Кол-во контингентов",
    directions: "Направления",
    aboutSchool: "О школе",
    courses: "курсы",
    address: "Адрес",
    phone_number: "Номер телефона",
    language: "Язык обучения",
    available_count: "Доступные места",
    ageRange: "Возрастной диапазон",
    linkCopied: "Ссылка скопирована!",
    linkCopiedSuccess: "Ссылка на курс успешно скопирована!",
    linkCopyError: "Не удалось скопировать ссылку.",
    is_gov: "Государственный?",
    gos_organization: "Государственная организация",
    private_organization: "Частная организация",
    free: "Бесплатно",
    perMonth: "₸/месяц",
    "schedule": "Расписание занятий",
    applicationSuccess: "Заявка подано",
    applicationError: "Ошибка",
    noCourses: "Курсы не найдены",
    noCenters: "Центры не найдены",
    addedToFavorites: "Добавлено в избранное",
    removedFromFavorites: "Курс удален из избранного",
    age: "лет"
  },

  dataTable: {
    rowsPerPage: "Строк на странице",
    all: "Все",
  },

  popularCourses: {
    title: "Нет данных",
  },

  reviews: {
    noReviews: "Отзывов пока нет",
  },

  notFoundPage: {
    errorTitle: "Страница не найдена",
    errorDescription:
      "К сожалению, страница, которую вы ищете, не существует. Возможно, она была удалена или вы ввели неправильный адрес.",
    backLink: "Вернуться на главную",
  },

  "days": {
    "monday": "Понедельник",
    "tuesday": "Вторник", 
    "wednesday": "Среда",
    "thursday": "Четверг",
    "friday": "Пятница",
    "saturday": "Суббота",
    "sunday": "Воскресенье"
  },

  tutoring: {
    tutoringTitle1: "Репетиторство",
    tutoringTitle2: "один на один",
    tutoringTitle3: "для детей и подростков",
    showPhoneBtn: "Показать телефон",
    month: "месяц",
    searchLabel: "Поиск курсов",
    year: "Лет",
    noTutors: "Репетиторы не найдены",
    perLesson: "₸/занятие"
  },

  vacancies: {
    vacanciesTitle: "Вакансии",
    replyBtn: "Показать телефон",
    searchLabel: "Поиск курсов",
    priceFrom: "от",
    onHands: "на руки",
    experience: "Опыт",
    schedule: "График",
    year: "г.",
    noVacancies: "Нет вакансий",
  },

  filter: {
    regionsTitle: "Регион",
    allRegionsTitle: "Все области",
    priceTitle: "Цена",
    priceFrom: "от",
    priceTo: "до",
    directionTitle: "Направление",
    allDirectionsTitle: "еще...",
    langOfInstructionsTitle: "Язык обучения",
    allLanguagesTitle: "Все языки",
    educationLevelTitle: "Уровень образования",
    workExperienceTitle: "Опыт работы",
    workScheduleTitle: "График работы",
  },

  profile: {
    profileTab: "Профиль",
    childrenTab: "Мои дети",
    requestsTab: "Мои заявки",
    tabelsTab: "Табели",
    accountDetails: "Данные учетной записи",
    name: "ФИО",
    email: "Электронная почта",
    workplace: "Место работы",
    phone: "Контактный номер",
    additionalPhone: "Доп. контактный номер",
    docType: "Вид документа",
    docNumber: "№ документа",
    issuedBy: "Кем выдано",
    issueDate: "Когда выдано",
    cancelButton: "Отменить",
    saveButton: "Сохранить",
    noSubjects: "Нет предметов",
    addChild: "Добавить",
    noChildren: "Дети еще не зарегистрированы",
    noChildrenDescription: "Чтобы добавить ребенка, нажмите кнопку «Добавить» и следуйте инструкциям.",
  },

  children: {
    calendarTitle: "Календарь и журнал",
    searchLabel: "Поиск курсов",
    share: "Поделиться расписанием",
    acts: "Табели",
    studyTime: "Уроков в неделю",
    class: "класс",
    actNumber: "Номер табеля",
    courseName: "Название курса",
    data: "Дата",
    teacher: "Учитель",
    status: "Статус",
    close: "Закрыть",
    branch: "Организация"
  },

  login: {
    title: "Вход в систему",
    byECP: "Через ЭЦП",
    byEGOV: "eGov mobile",
    chooseCertificateBtn: "Выберите сертификат",
    passwordLabel: "Пароль",
    loginBtn: "Вход",
    loginLogoText: "Дополнительное образование",
  },

  registration: {
    step: "шаг",
    steps: {
      firstStep: "1-шаг",
      secondStep: "2-шаг",
      thirdStep: "3-шаг",
    },
    firstStep: {
      title: "Персональные данные",
      documentTypeLabel: "Тип документа",
      documentNumberLabel: "№ документа",
      organ: "Орган выдачи",
      timeToGive: "Дата выдачи",
      iAgree: "Я согласен(на) на ",
      processingData: "обработку персональных данных",
      nextBtn: "Далее",
    },
    secondStep: {
      title: "Контактные данные",
      numberLabel: "Номер телефона",
      additionalNumberLabel: "Дополнительный номер телефона",
      emailLabel: "Email адрес",
      workplace: "Место работы",
      processingData: "даю согласие на обработку персональных данных ",
      saveBtn: "Сохранить",
      backBtn: "Назад",
    },
    thirdStep: {
      title: "Дети",
      description:
        "На ваш номер, зарегистрированный в БМГ, было отправлено SMS (СМС). Для добавления детей, пожалуйста, ответьте на это сообщение, отправив код, означающий <strong>«Да»</strong>",
      nextBtn: "Экспортировать",
      skip: "Пропустить",
      toProfileBtn: "Продолжить",
    },
  },

  acts: {
    actsList: "Список табелей",
    showAll: "посмотреть все",
    actNumber: "Номер табеля",
    actsDetail: {
      course: "Курс",
      date: "Дата",
      file: "Файл",
      hoursElapsed: "Количество посещений",
      reasonOfRefusal: "Причина отказа",
      backButton: "Назад",
      cancelButton: "Отклонить",
      acceptButton: "Принять",
      teacher: "Учитель",
      status: "Статус",
      actWithNumber: "Табель с номером",
      actSigned: "был успешно подписан",
      actRejected: "был отклонен родителем",
    },
    confirmTitle: "Подтверждение",
    confirmAcceptText: "Вы уверены, что хотите подписать табель?",
    confirmRejectText: "Вы уверены, что хотите отклонить табель?",
    confirm: "Да",
    cancel: "Нет",
    commentPlaceholder: "Комментарий",
    rejectCommentRequired: "Пожалуйста, укажите причину отказа.",
    diaryDate: "Дата",
    diaryTime: "Время",
    diaryStatus: "Статус занятия",
    diaryMark: "Оценка"
  },

  tabels: {
    studying: "Принято",
    expelled: "Отчислен",
    unsignedTabelCount: "Не подписанные табели",
    table: {
      center: "Учебный центр",
      course: "Курс",
      status: "Статус",
      actions: "",
    },
  },

  applications: {
    numberOfApplications: "Число заявок",
    lastApplication: "Последняя заявка",
    table: {
      center: "Учебный центр",
      course: "Курс",
      category: "Категория",
      status: "Статус",
      date: "Дата подачи",
      actions: "",
    },
    applicationDetail: {
      downloadFile: "Скачать файл",
      status: "Статус",
      reason: "Причина",
      birthCertificate: "Свидетельство о рождении",
      medicalCertificate: "Медицинская справка",
      category: "Категория",
      statement: "Заявление",
      submitted: "Подано",
      perMonth: "₸/месяц",
      toBeExpelledButton: "Отчислиться",
      ratings: "оценок",
      oneLesson: "Один урок",
      hours: "часа в неделю",
      perWeek: "",
      applicationNumber: "Номер заявки",
      downloadCertificate: "Скачать свидетельство",
      downloadMedicalCertificate: "Скачать справку",
      downloadApplication: "Скачать заявление",
      deleteApplication: "Удалить заявку",
      withdrawApplication: "Отчислиться",
      toCourse: "Перейти к курсу",
      deleteConfirmText: "Вы уверены, что хотите удалить заявку?",
      withdrawConfirmText: "Вы уверены, что хотите отчислиться?",
      confirmTitle: "Подтверждение",
      confirmDeleteText: "Вы уверены, что хотите удалить заявку?",
      confirmWithdrawText: "Вы уверены, что хотите отчислиться?",
      confirm: "Да",
      cancel: "Нет",
      socialCategoryDocument: "Справка социальной категории",
      downloadSocialCategoryDocument: "Скачать справку социальной категории",
      subGroupName: "Подгруппа",
    },
  },

  toastText: {
    successfullySaved: "Данные успешно сохранены!",
    errorData: "Ошибка при обработке запроса",
    loginError: "Ошибка при авторизации",
    ecpKey: "Введите ЭЦП ключ и пароль!",
    fields: "Заполните все поля",
    wentWrong: "Что-то пошло не так. Поробуйте еще раз!",
    sendSMS:
      "На ваш номер телефона отправлено СМС. Пожалуйста, ответьте на него и повторно нажмите кнопку.",
    actSuccessSubmit: "Табель успешно подписан",
    actReject: "Табель отклонен",
    applicationDeleted: "Заявка успешно удалена",
    applicationWithdrawn: "Вы успешно отчислены",
    saveError: "Ошибка при сохранении данных",
    formError: "Ошибка при подготовке формы",
    validationError: "Пожалуйста, проверьте введенные данные",
    serverError: "Ошибка сервера, попробуйте позже",
    smsNotAnswered: "Вы не ответили на СМС",
    childAddedSuccess: "Дети успешно добавлены",
    noChildrenFound: "Дети не найдены",
    smsAnsweredNoCorrectly: "Вы ответили на СМС некорректно",
    fileUploadError: "Ошибка при загрузки файла"
  },

  application: {
    selectStudent: "Выберите ребенка",
    selectStudentPlaceholder: "Выберите ребенка из списка",
    hasApplication: "уже подана заявка на этот курс",
    hasOverlimit: "превысил(а) лимит заявок",
    address: "Адрес проживания",
    addressPlaceholder: "Введите адрес проживания",
    socialCategory: "Социальная категория",
    socialCategoryPlaceholder: "Выберите социальную категорию",
    phoneNumber: "Контактный номер",
    phoneNumberPlaceholder: "Введите контактный номер",
    email: "Электронная почта",
    emailPlaceholder: "Введите электронную почту",
    selectSubgroup: "Выберите подгруппу",
    selectSubgroupPlaceholder: "Выберите доступную подгруппу",
    dataAgreement: {
      confirm: "Я даю согласие на обработку персональных данных"
    },
    memo: {
      confirm: "Я ознакомлен(а) с памяткой для родителей"
    },
    documents: {
      birthCertificate: "Свидетельство о рождении",
      medicalCertificate: "Медицинская справка",
      uploadPlaceholder: "Загрузить файл",
      socialCertificate: "Справка для подтверждения социальной категории",
      delete: "Удалить"
    },
    submitApplication: "Отправить заявку",
    cancel: "Отмена",
    available_count: "Доступные места",
    place: "Место",
    studyInCollege: "Учиться в колледже",
    exitConfirmation: {
      title: "Закрыть заявку?",
      message: "Все внесенные данные будут потеряны",
      continue: "Продолжить заполнение",
      exit: "Выйти"
    },
    loadingData: "Загружаем ваши данные...",
    "grade": "Класс",
    "gradePlaceholder": "Например: 5",
    "letter": "Буква класса", 
    "letterPlaceholder": "Например: А",
    "studentNotInSchool": "Не посещает школу",
    "schoolStatus": "Статус обучения",
    "studiesAtSchool": "Учится в школе",
    "notStudiesAtSchool": "Не посещает школу",
    "profileCompletionRequired": "Для подачи заявки необходимо заполнить все данные профиля. Перенаправляем на страницу профиля...",
    profileIncomplete: "Профиль не заполнен",
    profileCompleteRequired: "Для подачи заявки необходимо заполнить все данные профиля. Перенаправляем на страницу профиля...",
    redirectIn: "Перенаправление через",
    goToProfileNow: "К профилю",
    redirectingToProfile: "Перенаправляем на страницу профиля...",
    view: "Показать",
    hide: "Скрыть",
    schoolNamePlaceholder: "Например: Актау №20 школа",
    schoolName: "Школа",
    CollegeNamePlaceholder: "Например: Мангистауский колледж искусств",
    CollegeName: "Колледж"
  },

  validation: {
    required: "Это поле обязательно для заполнения",
    email: "Пожалуйста, введите корректный email адрес",
    phone: "Пожалуйста, введите корректный номер телефона",
    fillRequiredFields: "Заполните все обязательные поля",
    confirmMemoRequired: "Подтвердите ознакомление с памяткой",
    agreeRequired: "Необходимо согласие на обработку данных",
    socialDocumentRequired: "Загрузите справку подтверждающую социальную категорию",
    gradeAndLetterRequired: "Пожалуйста, укажите класс и литеру студента",
    onlyNumber: "Должны быть только цифры",
    maximum9: "Номер документа должен содержать только цифры (9 цифр)",
    futureDate: "Дата не может быть в будущем",
    notNecessary: "(не обязательно)",
    fileTooLarge: "Слишком большой файл"
  },

  favorites: {
    title: "Избранные курсы",
    subtitle: "Ваши избранные курсы ({count})",
    loading: "Загружаем ваши избранные курсы...",
    emptyTitle: "В избранном пока пусто",
    emptyText: "Сохраняйте понравившиеся курсы, чтобы легко найти их позже",
    exploreCourses: "Найти курсы",
    removed: "Курс удален из избранного"
  },

  dataAgreement: {
    title: "Согласие на обработку персональных данных "
  },

  memo: {
    title: "Памятка для родителей"
  },

  auth: {
    sessionExpired: "Ваша сессия истекла. Пожалуйста, войдите снова."
  }
};
